import React, { useEffect } from 'react';
import { renderTaskDetailDynamicFields } from '../../../../tasks/scenes/task-create-edit/helpers/task-helpers';
import PropTypes from 'prop-types';
import { getProjectDynamicFields } from '../helpers/project-helpers';

function ProjectDynamicFields({
    dynamicFields,
    setDynamicFields,
    templateId,
    projectId = 0,
}) {
  const dynamicFieldRequestDto = {
    projectTypeId: templateId,
    objectType: "Project",
    objectId: projectId // default set to 0 -> project create scenario
  };

  useEffect(() => {
      getProjectDynamicFields(dynamicFieldRequestDto)
          .then(setDynamicFields)
          .catch((error) => {
              setDynamicFields([]);
              console.error(error);
          });
  }, [templateId, projectId]);

  return (
    <div>
      {dynamicFields.filter((item) => item.FieldType !== 'Table')?.length > 0 &&
          <div className="dynamic-section-container">
              {renderTaskDetailDynamicFields({
                  dynamicFields: dynamicFields.filter((item) => item.FieldType !== 'Table'),
                  setDynamicFields,
                  taskWithWorkflow: projectId
              })}
          </div>
      }
    </div>
  )
}

export default ProjectDynamicFields;

ProjectDynamicFields.propTypes = {
  templateId: PropTypes.number,
  projectId: PropTypes.number,
}